import { Component, OnInit, TemplateRef } from '@angular/core';
import { LoadService } from '../../services/load.service';
import { OrdensalidaService} from '../../services/ordensalida.service';
import { FormGroup, FormControl, Validators} from '@angular/forms';
import { StockService } from '../../services/stock.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as $ from 'jquery';

@Component({
  selector: 'app-ordenespendientes',
  templateUrl: './ordenespendientes.component.html',
  styleUrls: ['./ordenespendientes.component.css']
})
export class OrdenespendientesComponent implements OnInit {
public orders:any[];
public order_actual:any;
public tags_from_orders:any[];
public groups_from_order:any[];
public tags_verified:any[];
public alert:string;
public isopen:boolean;
public habilitar_aprovacion:boolean;
public orden_seleccionada:boolean;
public cajas_verificadas:number;
public cajas_pendientes:number;
public cajas_pistoleadas:number;
public BsModalRef:BsModalRef;
public formBuscar:FormGroup;
public codeCaja:string;
public loading:boolean;
public comenzar:boolean;
  constructor(private _loaddata:LoadService, private _ordenSalidaService:OrdensalidaService, private _stockService:StockService, private bsModalService:BsModalService) {
    this.orders = [];
    this.order_actual = null;
    this.tags_from_orders = [];
    this.tags_verified = [];
    this.alert = '';
    this.isopen = false;
    this.orden_seleccionada = false;
    this.habilitar_aprovacion = false;
    this.cajas_verificadas = 0;
    this.cajas_pendientes = 0;
    this.cajas_pistoleadas = 0;
    this.comenzar = false;
    this.formBuscar = new FormGroup({
      'qr': new FormControl('',Validators.required)
    });
    this.codeCaja = 'Pistolee las cajas';

    $(document).keypress((e)=> {

      let codigo = this.formBuscar.get('qr').value;
      codigo+=e.key;
      //Seteando el valor del input
      //$('#codeCaja').val(bla);
      this.formBuscar.setValue({
        'qr':codigo
      });

      if (e.which == 13) {
           // Se presionó la tecla enter
          let code = this.formBuscar.get('qr').value;
           //dejando en vacio el valor del input
           //$('#codeCaja').val('');

           //this.code = code;
           // don't submit the form
           //e.preventDefault();
           console.log("presiono enter", code);
           this.buscarCajaNew(code);
       }

    });
   }

  ngOnInit() {
    this.loading = true;
    this.cargarOrdenes();
  }

  verOrden(orden:any){
    this.alert = 'Cargando Orden...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    this.orden_seleccionada = true;
    this.order_actual = orden;
    this._ordenSalidaService.getTagsOrder(this.order_actual.id).subscribe((response:any)=>{
      this.alert = 'Orden Cargada.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      this.groups_from_order = response.data;
      console.log('Grupos de cajas',response.data);
      for(let group of this.groups_from_order){
        for(let tag of group.relationships.tags.data){
          this.tags_from_orders.push(tag);
        }
      }
      if((this.tags_from_orders.length - this.order_actual.relationships.tags.data.length)==0){
        this.cajas_pendientes = this.order_actual.relationships.tags.data.length;
        this.cajas_verificadas = 0;
        this.cajas_pistoleadas = 0;
      }
      else{
        this.cajas_pendientes = this.tags_from_orders.length;
        this.cajas_verificadas = this.order_actual.relationships.tags.data.length - this.cajas_pendientes;
        this.cajas_pistoleadas = 0;
      }

    },error=>{
      this.alert = 'Algo salió mal.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
      console.log('ERROR:',error.error.error);
    });

    console.log("tags: ", this.tags_from_orders);
    this.formBuscar.reset();
    this.formBuscar.setValue({
      'qr': ''
    });
  }

  cargarOrdenes(){
    this.loading = true;
    this.alert = 'Cargando Ordenes Aprobadas...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    this._ordenSalidaService.getApprovatedOrders().subscribe((response:any)=>{
      this.loading = false;
      for(let order of response.data){
        if(order.relationships.tags.data.length > 0){
          this.orders.push(order);
        }
      }
      console.log("ordenes: ", this.orders);
      this.alert = 'Ordenes Aprobadas Cargadas.';
      this.isopen = true;
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },error=>{
      console.log("No se han podido Cargar las Ordenes", error.error.error);
    });
  }

  volver(){
    this.orden_seleccionada = false;
    this.order_actual = null;
    this.tags_from_orders = [];
    this.tags_verified = [];
    this.cajas_verificadas = 0;
    this.cajas_pendientes = 0;
    this.cajas_pistoleadas = 0;
    this.habilitar_aprovacion = false;
    this.comenzar = false;
    this.formBuscar.reset();
    this.formBuscar.setValue({
      'qr':''
    });
    this.orders = [];
    this.cargarOrdenes();
  }

  buscarCaja(){
    let qr = this.formBuscar.get('qr').value;
    console.log('qr', qr);
    this.alert = "Buscando caja...";
    this.isopen = true;
    this._loaddata.loadChange(20);
    let variable = '';
    let guion = 0;
    let prefijopallet = '';
    let sufijocaja = '';
    let prefijo = 0;
    let sufijo = 0;

    /*Derrepente la pistola lee 3 caracteres raros*/
    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    /*P18-0000-131-*/
    if(qr.charAt(0) == 'P' && qr.charAt(3) == '-' && parseInt(qr.charAt(2)) < 9 && parseInt(qr.charAt(2)) > 0 && parseInt(qr.charAt(1)) < 9 && parseInt(qr.charAt(1)) > 0){
      //console.log("se ha ingresado un código de pallet");
    }
    else{
      for(let char of qr){
        if(char != '-'){
          variable += char
        }
        else if(guion == 0){
          prefijo = parseInt(variable);
          variable = '';
          guion = 1;
        }
        else if(guion == 1){
          sufijo = parseInt(variable);
          variable = '';
          guion = 2;
        }
      }

      if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
            let tag = this.tags_from_orders.filter(function(t){
                   return `${t.attributes.prefix}-${t.attributes.suffix}` === `${prefijo.toString()}-${sufijo.toString()}`;
            })[0];

            this.tags_verified.push(tag);

            tag.attributes.verified = true;
            this.cajas_verificadas++;
            this.cajas_pendientes--;
            this.cajas_pistoleadas++;
            /*if((this.order_actual.relationships.tags.data.length - this.cajas_verificadas) == 0){
              this.habilitar_aprovacion = true;
            }*/
            this.borrarFormulario();
            this.alert = 'Caja Encontrada.';
            this.isopen = true;
            this._loaddata.loadChange(100);
            this.isopen = false;
            /*console.log("tag:",tag);
            console.log("tags de la orden : ", this.tags_from_orders);
            console.log("tags verificadas: ",this.tags_verified);*/
      }
      else{
        this.alert = "Codigo QR invalido.";
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      }
    }
  }

  buscarCajaNew(q){
    //let qr = this.formBuscar.get('qr').value;
    let qr = q;
    console.log('qr', qr);
    this.alert = "Buscando caja...";
    this.isopen = true;
    this._loaddata.loadChange(20);
    let variable = '';
    let guion = 0;
    let prefijopallet = '';
    let sufijocaja = '';
    let prefijo = 0;
    let sufijo = 0;

    /*Derrepente la pistola lee 3 caracteres raros*/
    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    /*P18-0000-131-*/
    if(qr.charAt(0) == 'P' && qr.charAt(3) == '-' && parseInt(qr.charAt(2)) < 9 && parseInt(qr.charAt(2)) > 0 && parseInt(qr.charAt(1)) < 9 && parseInt(qr.charAt(1)) > 0){
      //console.log("se ha ingresado un código de pallet");
    }
    else{
      for(let char of qr){
        if(char != "-"){
          variable += char
        }
        else if(guion == 0){
          prefijo = parseInt(variable);
          variable = '';
          guion = 1;
        }
        else if(guion == 1){
          sufijo = parseInt(variable);
          variable = '';
          guion = 2;
        }
      }

      if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
            let tag = this.tags_from_orders.filter(function(t){
                   return `${t.attributes.prefix}-${t.attributes.suffix}` === `${prefijo.toString()}-${sufijo.toString()}`;
            })[0];

            if(tag != undefined && tag != 'undefined'){
              this.tags_verified.push(tag);

              tag.attributes.verified = true;
              this.cajas_verificadas++;
              this.cajas_pendientes--;
              this.cajas_pistoleadas++;
              /*if((this.order_actual.relationships.tags.data.length - this.cajas_verificadas) == 0){
                this.habilitar_aprovacion = true;
              }*/
              this.borrarFormulario();
              this.alert = 'Caja Encontrada.';
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.isopen = false;
              /*console.log("tag:",tag);
              console.log("tags de la orden : ", this.tags_from_orders);
              console.log("tags verificadas: ",this.tags_verified);*/
            }
            else{
              this.alert = "Caja no Encontrada";
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.borrarFormulario();
              this.onClosedAutomatic();
            }


      }
      else{
        this.alert = "Codigo QR invalido.";
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.borrarFormulario();
        this.onClosedAutomatic();
      }
    }
  }

  showAprobarOrden(template: TemplateRef<any>){
    this.BsModalRef = this.bsModalService.show(template);
  }

  cerrarOrden(){
    this.alert = 'Confirmando Salida de Cajas...';
    this.isopen = true;
    this._loaddata.loadChange(40);
    console.log("CERRANDO ORDEN:", this.order_actual);
    let body = this._ordenSalidaService.transformDataDeleteAllTags(this.tags_verified,this.order_actual.id);
    console.log("body peticion eliminar cajas: ", body);
    this._ordenSalidaService.deleteTagsFromOrder(this.order_actual.id,body).subscribe((response:any)=>{
        console.log("respuesta eliminacionde cajas de la orden: ",response);
        this.alert = 'Cajas Eliminadas del Stock.';
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
        this.cerrarModalAprobar();
        this.volver();
    },error=>{
      console.log("No se han eliminado las cajas: ",error.error.error);
    });
  }

  cerrarModalAprobar(){
    this.BsModalRef.hide();
  }

  borrarFormulario(){
    this.formBuscar.reset();
    this.formBuscar.setValue({
      'qr':''
    });
  }

  onClosedAutomatic(){
    setTimeout(()=>{
      this.isopen = false;
      this.alert = '';
    },3000);
  }

  onClosed(){
    this.isopen = false;
    this.alert = '';
  }

  comenzarPistoleo(){
    this.comenzar = true;
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/ordenespendientes/ordenespendientes.component.ts